import styled from 'styled-components';
import { Body1, Body2, colors, spacing } from 'ui/theme';
import { Card } from 'ui/cardV2';
import { ReactNode } from 'react';
import { DashboardSectionTitle } from '../Dashboard.styled';
import { Container } from 'ui/container';
import type { Option } from 'ui/radioGroup/types';
import { PartialBy } from 'utils/tsHelpers';
import { FlexSpacer } from 'ui/flexSpacer';
import { RadioGroup } from 'ui/radioGroup/radioGroup';

const Title = styled(DashboardSectionTitle)`
  margin-bottom: ${spacing.base};
`;

const Subtitle = styled(Body1)`
  margin: 0;
  padding: 0;
  width: 100%;
  margin-bottom: ${spacing.base};
  color: ${colors.textSecondary};
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${spacing.half};
`;

export const Image = styled.img`
  height: 40px;
  width: 40px;
`;

const FeatureContainer = styled(Container)`
  width: 100%;
`;

type FeatureOption = {
  title: ReactNode;
  label: string;
  name: string;
  value: string;
  onSelect: (value: string) => void;
  options: Option[];
};

type DevPanelFeatureProps = {
  title: ReactNode;
  features?: FeatureOption[];
  feature?: PartialBy<FeatureOption, 'title'>;
};

export const DevPanelFeature = ({ title, feature, features }: DevPanelFeatureProps) => {
  return (
    <Card size="small">
      <Title>{title}</Title>

      <FlexSpacer gap="base" flexDirection="column" alignSelf="stretch">
        {!!features?.length &&
          features.map(
            ({
              title: subtitle,
              label = 'Select a state',
              name = label,
              value,
              onSelect,
              options,
            }) => (
              <FeatureContainer key={name || value} hasBorder={false} variant="secondary">
                {subtitle && <Subtitle>{subtitle}</Subtitle>}
                <RadioGroup
                  isBordered={false}
                  label={label}
                  name={name}
                  value={value || undefined}
                  onSelect={onSelect}
                  options={options}
                />
                {!options.length && (
                  <Body2 style={{ color: colors.textSecondary }}>
                    No options available for this feature. Please check the configuration.
                  </Body2>
                )}
              </FeatureContainer>
            ),
          )}
      </FlexSpacer>

      {feature && (
        <RadioGroup
          isBordered={false}
          label={feature.label}
          name={feature.name}
          value={feature.value || undefined}
          onSelect={feature.onSelect}
          options={feature.options}
        />
      )}
    </Card>
  );
};
